<template>
  <div>
    <BannerHero />
    <!-- <SellerDashboardTease class="bg-white" /> -->
    <BrandsSection class="bg-white" />
    <PlatformFeatures />
    <PlatformFees />
    <WhySwitch />
    <SaveBig />
    <SellPricing />
    <SellFaqs />
    <GetStarted class="guide-divider" cta="Start for A$1" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BannerHero from "@/components/heros/HomeBanner.vue";
// import SellerDashboardTease from "@/components/sections/SellerDashboardTease.vue";
import BrandsSection from "@/components/sections/Brands.vue";
// import WaysToSell from "@/components/sections/WaysToSell.vue";
import PlatformFees from "@/components/sections/PlatformFees.vue";
import PlatformFeatures from "@/components/sections/PlatformFeatures.vue";
import WhySwitch from "@/components/sections/WhySwitch.vue";
import SaveBig from "@/components/sections/SaveBig";
// import PlatformServices from "@/components/sections/PlatformServices.vue";
// import PlatformAudience from "@/components/sections/PlatformAudience.vue";
import SellPricing from "@/components/sections/SellPricing.vue";
import SellFaqs from "@/components/sections/SellFaqs.vue";
import GetStarted from "@/components/sections/GetStarted.vue";

export default defineComponent({
  components: {
    BannerHero,
    // SellerDashboardTease,
    BrandsSection,
    PlatformFees,
    PlatformFeatures,
    WhySwitch,
    SaveBig,
    SellPricing,
    SellFaqs,
    GetStarted,
  },
  setup() {
    definePageMeta({
      layout: "sell",
    });
  },
});
</script>
